import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PaymentCard } from 'components/ui';
import styles from './PaymentMethods.module.scss';
import { resetPaymentMethodError } from 'store/actions/paymentMethods';
import { paymentsSelector } from 'store/reducers/paymentMethods.reducer';
import { PreloaderWrapper } from 'components/containers/PreloaderWrapper/PreloaderWrapper';
import CardSetupForm from 'components/grid/Payment/CardSetupForm/CardSetupForm';
import Alert from 'components/ui/Alert/Alert';
import { PaymentMethod } from '@stripe/stripe-js';
import { CustomerPaymentMethods } from 'types/stripe';
import { useFetcher } from 'utils/fetcher';
import SmallPreLoader from 'components/ui/SmallPreLoader/SmallPreLoader';
import clsx from 'clsx';
import StripeModal from 'components/ui/Modal/StripeModal';

type PaymentMethodProps = {
  dontShowTitle: boolean;
};

export const PaymentMethods = ({ dontShowTitle = false } = {} as PaymentMethodProps) => {
  const dispatch = useDispatch();
  const [isPaymentForm, setIsPaymentForm] = React.useState<boolean>(false);
  const [, setFormPurpose] = React.useState<string>('');
  const { isFetching, isUpdating, error } = useSelector(paymentsSelector);
  const [isStripeModalOpen, setIsStripeModalOpen] = React.useState(false);
  const [cardId, setCardId] = React.useState<string>('');
  const [deleteRes, setDeleteRes] = React.useState<any>({});

  const { data, isLoading, mutate } = useFetcher<CustomerPaymentMethods>(
    '/api/v2/patient/cards/stripe_customer_payment_methods',
  );


  const handleEdit = (purpose: string) => {
    setFormPurpose(purpose);
    setIsPaymentForm(true);
  };

  const handleClose = () => {
    setFormPurpose('');
    setIsPaymentForm(false);
    dispatch(resetPaymentMethodError());
  };
//   useEffect(() => {
//     fetchData();
// }, [data]);
  const renderPaymentCards = () => {
    if (isFetching || isUpdating) return <PreloaderWrapper />;

    return (
      <div className="row">
        <div className="col-12">
          {error && <Alert type="error">{error?.toString()}</Alert>}
          <div className={clsx(styles.cardsContainer, 'row mt-3')}>
            {!isLoading && data ? (
              data.data.map((item: PaymentMethod | any) => (
                <PaymentCard
                  key={item?.id}
                  cardId={item?.id}
                  type={item.card?.brand}
                  radioValue={item?.id}
                  cardNumber={item?.card?.last4 || ''}
                  isDefault={false}
                  handleEditCard={handleEdit.bind(null, 'edit')}
                  mutate={mutate}
                />
              ))
            ) : isLoading ? (
              <SmallPreLoader />
            ) : null}
            <StripeModal mutate={mutate} modalStates={[isStripeModalOpen, setIsStripeModalOpen]} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="row my-5 p-3">
      <div className="col-12">
        {isPaymentForm ? <CardSetupForm handleCloseForm={handleClose} /> : renderPaymentCards()}
      </div>
    </div>
  );
};
